import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

export const useMessageTemplatesFeatureAvailability = () => {
  const { featureAvailability } = useFeatureAvailability(Features.ats_message_templates)

  return hasFeature('dev_packaging_paywalls')
    ? featureAvailability.available
    : hasFeature('ats_message_templates')
}
